import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import moment from 'moment'
import Chart from 'chart.js'
import { SERVER_URL } from './ServerConfig'
import queryString from 'query-string';
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const AnyReactComponent = ({ text }) => <div>{text}</div>;

export default class Dashboard extends Component {
    constructor(props) {
        super(props);

        let params = queryString.parse(this.props.location.search);
        this.state = {
            isLoading: true,
            plumbCreated: false,
            inverters: [],
            totalEnergy: 0.0,
            totalACPowwer: 0.0,
            installedPower: 1.0,
            installedkWAC: 1.0,
            station: null,
            money: {
                summaryDay: 0.0,
                summaryMonth: 0.0,
                summaryYear: 0.0,
            },
            moneyOfYear: {
                summaryYear: 0.0
            },
            name: '',
            params: params,
            weather: null,
            warnings: []
        }
        this.connections = []
        this.handleNavigateToSettings = this.handleNavigateToSettings.bind(this);
    }

    componentDidMount() {
        if (!this.props.user) {
            return;
        }

        const pathName = window.location.pathname;
        if (pathName !== '/' && !pathName.startsWith("/dashboard")) {
            return;
        }

        if (!this.state.params || !this.state.params.station) {
            this.fetchStations();
        } else {
            this.fetchStation(this.state.params.station);
        }
    }

    fetchStations() {
        let user = this.props.user.payload.user;
        let token = this.props.user.payload.token;
        let project = user.member.mProjectID;

        fetch(SERVER_URL + '/v1/projects/' + project._id + '/getStations', {
            headers: {
                'x-access-token': token
            }
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (data && data.success) {
                    let stations = data.content;
                    if (stations.length > 0) {
                        this.props.history.push("/dashboard?station=" + stations[0]._id);
                        this.props.handleUpdateStation(stations[0]);
                        this.fetchStation(stations[0]._id);
                    }
                }
            })
    }

    fetchAlarms(station, token) {
        let stationId = station._id;
        fetch(SERVER_URL + '/v1/stations/' + stationId + '/latestWarningInverters', {
            headers: {
                'x-access-token': token
            }
        }).then(response => {
            if (response.status === 403) {
                this.props.history.push("/login");
            } else {
                return response.json();
            }
        }).then(data => {
            if (data.success) {
                this.setState({ warnings: data.content });
            }
        });
    }

    componentWillUnmount() {
        this.unmounted = true;
    }

    fetchStation(stationId) {
        if (this.unmounted) {
            return;
        }
        let token = this.props.user.payload.token;
        fetch(SERVER_URL + '/v1/stations/' + stationId, {
            headers: {
                'x-access-token': token
            }
        }).then(response => {
            if (response.status === 403) {
                this.props.history.push("/login");
            } else {
                return response.json();
            }
        })
            .then(data => {
                if (data && data.success) {
                    let station = data.content;
                    this.setState({ station: station, name: station.mName, installedPower: station.mInstalledPower, installedkWAC: station.mInstalledkWAC })
                    this.fetchInverters(station, token);
                    this.fetchTodaySummary(station, token);
                    this.fetchWeather(station);
                    this.fetchAlarms(station, token);
                }
            })
            .catch(err => {
                this.props.history.push("/login");
            });
    }

    fetchWeather(station) {
        if (station.mLat && station.mLong) {
            let url = 'http://api.openweathermap.org/data/2.5/weather?lat=' + station.mLat + '&lon=' + station.mLong + '&appid=261eca27f0e587915b07bcdb99976f64&lang=vi'
            fetch(url)
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    this.state.weather = data;
                });
        }

    }

    fetchMoneySummary(station, token) {
        let day = moment().toISOString();
        fetch(SERVER_URL + '/v1/stations/' + station._id + '/getMoneySummary', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': token
            },
            body: JSON.stringify({
                day: day
            })
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (this.unmounted) {
                    return;
                }
                this.setState({ money: data.content });
                this.fetchMoneySummaryOfYear(station, token);
            })
    }

    fetchMoneySummaryOfYear(station, token) {
        let day = moment().toISOString();
        fetch(SERVER_URL + '/v1/stations/' + station._id + '/getMoneySummaryOfYear', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': token
            },
            body: JSON.stringify({
                day: day
            })
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (this.unmounted) {
                    return;
                }
                this.setState({ moneyOfYear: data.content });
            })
    }


    fetchInverters(station, token) {
        fetch(SERVER_URL + '/v1/stations/' + station._id + '/inverters_current', {
            headers: {
                'x-access-token': token
            }
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                if (this.unmounted) {
                    return;
                }
                this.interval = setInterval(() => this.doFetchInterval(station, token), 5000);
                var tempEnergy = 0;
                var tempACPowwer = 0;
                data.content.map((inverter) => {
                    if (inverter.current.length > 0) {
                        let status = this.getStatus(inverter.current[0], inverter.current[0].mStatus);
                        if (status) {
                            tempEnergy += inverter.current[0].mEnergy;
                            tempACPowwer += inverter.current[0].mACpower;
                        }
                    }
                });
                this.setState({ isLoading: false, inverters: data.content, totalEnergy: tempEnergy, totalACPowwer: tempACPowwer });
            })
    }

    fetchTodaySummary(station, token) {
        let day = moment().toISOString();
        fetch(SERVER_URL + '/v1/stations/' + station._id + '/getEnergySummaryOfDay', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'x-access-token': token,
            },
            body: JSON.stringify({
                day: day
            })
        })
            .then(response => {
                if (response.status === 403) {
                    this.props.history.push("/login");
                } else {
                    return response.json();
                }
            })
            .then(data => {
                let content = data.content;
                let keys = Object.keys(content);

                let keyData = [];
                keys.forEach(e => {
                    keyData.push(moment(e).format("HH:mm"))
                });

                let values = Object.values(content);

                let valuesData = [];
                values.forEach(e => {
                    if (e >= 0) {
                        valuesData.push(this.formatNumber(e));
                    }
                });

                this.drawMap(station);

                this.drawCanvas(keyData, valuesData);

                this.fetchMoneySummary(station, token);
            })
    }

    drawMap(station) {
        if (station && station.mLat && station.mLong) {
            let center = [station.mLong, station.mLat]
            let zoom = 13;
            var goongjs = window.goongjs;
            goongjs.accessToken = 'TM230itb5cj0ubcNqRvgrVZqV69K75pEeyK1ajGr';
            var map = new goongjs.Map({
                container: 'map', // container id
                style: 'https://tiles.goong.io/assets/goong_map_web.json', // stylesheet location
                center: center, // starting position [lng, lat]
                zoom: zoom // starting zoom
            });
            map.addControl(new goongjs.NavigationControl());
            var marker = new goongjs.Marker()
                .setLngLat(center)
                .addTo(map);

            var popup = new goongjs.Popup()
                .setLngLat(center)
                .setHTML("<strong>" + station.mName + "</strong>");
            marker.setPopup(popup);
        }
    }

    drawCanvas(keys, values) {
        var ctx = document.getElementById('myChart');
        if (ctx) {
            var myChart = new Chart(ctx, {
                type: 'line',
                data: {
                    labels: keys,
                    datasets: [{
                        label: 'Energy (kW)',
                        data: values,
                        borderColor: [
                            'rgba(247,70,74,1)',
                        ],
                        pointBorderColor: [
                            'rgba(255, 0, 0, 1)'
                        ],
                        pointBackgroundColor: [
                            'rgba(255, 0, 0, 1)'
                        ],
                        borderWidth: 1.5,
                        pointHitRadius: 2,
                        fill: false,
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            ticks: {
                                maxTicksLimit: 8
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                maxTicksLimit: 5
                            }
                        }]
                    },
                    elements: {
                        point: {
                            radius: 0
                        }
                    }
                }
            });
        }

    }

    doFetchInterval(station, token) {
        clearInterval(this.interval);
        this.fetchInverters(station, token);
    }

    handleCombinerBoxesClick(inverter) {
        this.props.history.push("/combinerboxes?id=" + inverter._id);
    }

    getWarningFormInverter(item, inverter_current) {
        let warning = this.state.warnings[item.mIP];
        if (this.state.warnings[item.mIP]) {
            let code = warning.code;
            if (code && code.code) {
                if (code.code !== 4) {
                    if (code.led === 'error') {
                        return (
                            <Link to={"/alarms?station=" + this.state.station._id}>
                                <span className="badge bg-danger alarm-badge">{warning.code.code}: {warning.code.display}</span>
                            </Link>
                        )
                    }
                    return (
                        <Link to={"/alarms?station=" + this.state.station._id}>
                            <span className="badge bg-warning alarm-badge">{warning.code.code}: {warning.code.display}</span>
                        </Link>
                    )
                }
                return (
                    <Link to={"/alarms?station=" + this.state.station._id}>
                        <span className="badge bg-success alarm-badge">{warning.code.code}: {warning.code.display}</span>
                    </Link>
                )
            } else {
                return (
                    <Link to={"/alarms?station=" + this.state.station._id}>
                        <span className="badge bg-warning alarm-badge">{parseInt(warning.mNEWStatus, 16)}: Check status code</span>
                    </Link>
                )
            }
        }
        return (
            <span className="badge bg-success alarm-badge" style={{ visibility: 'hidden' }}>OK</span>
        )
    }

    getInverters(item, idx) {
        let inverterIdx = idx + 1;
        let inverter_current = {};
        if (item.current.length > 0) {
            inverter_current = item.current[0];
        }

        let status = this.getStatus(inverter_current, inverter_current.mStatus);
        return (
            <div className="inverter-entry col-xs-12 col-xl-3" key={inverterIdx}>
                <div id={"inverter" + inverterIdx} className="card m-1">
                    <div className="d-flex justify-content-center align-items-center mt-1">
                        {this.drawStatus(status)}
                        <Link to={"/inverter?id=" + item._id} className="ml-2 mr-2 d-inline-flex">
                            <div>{item.mName}</div>
                        </Link>
                    </div>
                    <div className="d-flex justify-content-center">
                        {this.getWarningFormInverter(item, inverter_current)}
                    </div>
                    <div className="ml-2 mr-2 mb-2">
                        <div className="col-md-12 d-flex">
                            <div className="left-inverter col-md-6 d-flex flex-column align-items-center">
                                <div className="lbl-inverter-energy col-md-12 d-flex align-items-center justify-content-center">
                                    <button type="button" className="btn-primary btn-sm mt-4 ml-1">{this.formatNumberWithStatus(inverter_current.mEnergy / 1000, status)} MWh</button>
                                </div>
                                <div className="d-flex align-items-center mt-1">
                                    <img className="img-inverter" src="img/inverter/inverter_2.png" />
                                </div>
                                <button type="button" className="btn btn-success btn-sm mt-1" onClick={() => this.handleCombinerBoxesClick(item)}>String monitoring</button>
                            </div>
                            <div className="col-md-6 d-flex flex-column align-items-center">
                                <b>P (kW)</b>
                                <button type="button" className="btn btn-block btn-primary btn-sm mb-1">{this.formatNumberWithStatus(inverter_current.mACpower / 1000, status)}</button>
                                <b>Q (var)</b>
                                <button type="button" className="btn btn-block btn-primary btn-sm mb-1">{this.formatNumberWithStatus(inverter_current.mACReaPower / 1000, status)}</button>
                                <b>Temp (°C)</b>
                                <button type="button" className="btn btn-block btn-primary btn-sm mb-1">{this.formatNumberWithStatus(inverter_current.mTemp, status)}</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getStatus(item, mStatus) {
        if (!mStatus) {
            return false;
        }
        const now = moment();
        const statusTime = moment(item.mTime);

        const duration = now.diff(statusTime, 'minutes');

        if (duration > 15) {
            return false;
        }
        return true;
    }

    drawStatus(status) {
        if (status) {
            return (
                <span className="dot-success"> </span>
            );
        }
        return (
            <span className="dot-danger"></span>
        );
    }

    getBody(inverters) {
        if (this.state.isLoading) {
            return (
                <div />
            );
        } else {
            return inverters.map((item, idx) => {
                return this.getInverters(item, idx);
            })
        }
    }

    formatNumber(number) {
        if (!number) {
            return 0;
        }
        return Number(number).toFixed(1);
    }


    formatNumberWithInteger(number) {
        if (!number) {
            return 0;
        }
        return Number(number).toFixed(0);
    }

    formatNumberWithStatus(number, status) {
        if (!status) {
            return 0;
        }
        return this.formatNumber(number);
    }

    getGauge() {

        let percentage = this.formatNumber(this.state.totalACPowwer / 1000 / this.state.installedkWAC * 100);
        return (
            <CircularProgressbar
                className="circle-progressbar"
                maxValue={100}
                value={percentage}
                text={`${percentage}%`}
            />
        );
    }

    handleNavigateToSettings(e) {
        this.props.history.push("/settings?station=" + this.state.station._id);
    }

    getStationAvatar() {
        if (this.state.station) {
            let avatarUrl = this.state.station.mAvatar;
            if (avatarUrl) {
                return <img className="imgDashBoard" src={SERVER_URL + "/" + avatarUrl} onClick={this.handleNavigateToSettings} />
            } else {
                return (
                    <div className="icon" onClick={this.handleNavigateToSettings}>

                        <i className="ion ion-person"></i>
                    </div>
                );
            }
        } else {
            return (
                <div className="icon" onClick={this.handleNavigateToSettings}>
                    <i className="ion ion-person"></i>
                </div>
            );
        }
    }

    getLinkToEnergyDetails() {
        if (this.state.station) {
            return "/energy-details?station=" + this.state.station._id;
        } else {
            return "#";
        }
    }

    getRenderWeather() {
        if (!this.state.weather) {
            return;
        }
        let weather = this.state.weather;
        if (!weather || !weather.main) {
            return;
        }
        let temp = weather.main.temp - 273;
        let icon = weather.weather[0].icon
        let iconLink = "/img/weather/" + icon + "@2x.png"
        return (
            <div className="weather small-box">
                <div className="info-box-content d-flex">
                    <img src={iconLink} width="50px" height="50px" alt="" />
                    <div className="mt-1 d-flex">

                        <h4>{this.formatNumber(temp)}</h4>
                        <div>°C</div>
                    </div>
                </div>
            </div>
        )
    }

    handleMapLoaded(map, maps) {
        if (map && maps) {
            let marker = new maps.Marker({
                position: { lat: this.state.station.mLat, lng: this.state.station.mLong },
                map,
                title: this.state.station.mName
            });
        }
    }

    getRenderMaps() {
        let station = this.state.station;
        if (station && station.mLat && station.mLong) {
            return (
                // Important! Always set the container height explicitly
                <div id="map" style={{ height: '300px', width: '100%' }}>
                </div>
            );
        }
    }

    render() {
        const inverters = this.state.inverters;
        if (!this.state.station) {
            return (
                <div></div>
            )
        }
        return (
            <div className="content-wrapper">
                <section className="content">
                    <div className="container-fluid dashboard-main">
                        <div className="row d-flex align-items-stretch">
                            <div className="col-md-4">
                                <div className="small-box bg-info">
                                    <div className="inner">
                                        <div className="row">
                                            <div className="col-md-6 col-lg-4 border-right">
                                                <div className="description-block">
                                                    <h5 className="description-header">kWp</h5>
                                                    <span className="description-text">{this.state.installedPower}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-4">
                                                <div className="description-block">
                                                    <h5 className="description-header">kWAC</h5>
                                                    <span className="description-text">{this.state.installedkWAC}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.getStationAvatar()}
                                </div>

                                <div style={{ 'position': 'relative' }}>
                                    <div>
                                        <div className="d-flex">
                                            <canvas id="myChart" height="300"></canvas>
                                        </div>
                                        <div className="d-flex justify-content-center mt-2">
                                            <Link to={this.getLinkToEnergyDetails()}>Click for details</Link>
                                        </div>
                                    </div>
                                    {this.getRenderWeather()}
                                </div>
                            </div>
                            <div className="col-md-4 d-flex align-items-stretch">
                                <div className="small-box col-md-12 d-flex flex-column" >
                                    <div className="col-md-12 d-flex flex-column">
                                        <h4 className='mt-1'>Station status</h4>
                                        {this.getGauge()}
                                        <div className="d-flex flex-column mt-4">
                                            <div className="d-flex flex-column m-2">
                                                <div className="row mt-2">
                                                    <b className="col-md-6">Energy</b>
                                                    <button type="button" className="col-md-6 btn btn-block btn-primary btn-sm mb-1">{this.formatNumber(this.state.totalEnergy / 1000)} MWh</button>
                                                </div>
                                                <div className="row mt-2">
                                                    <b className="col-md-6">AC Power</b>
                                                    <button type="button" className="col-md-6 btn btn-block btn-primary btn-sm mb-1">{this.formatNumber(this.state.totalACPowwer / 1000)} kW</button>
                                                </div>
                                                <div className="row mt-2">
                                                    <b className="col-md-6">PR</b>
                                                    <button type="button" className="col-md-6 btn btn-block btn-primary btn-sm">--</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="small-box bg-success">
                                    <div className="inner">
                                        <div className="row">
                                            <div className="col-sm-4 border-right">
                                                <div className="description-block">
                                                    <h5 className="description-header">Today</h5>
                                                    <span className="description-text">{this.formatNumber(this.state.money.summaryDay)} USD</span>
                                                    <br></br>
                                                    <span className="description">{this.formatNumber(this.state.money.summaryDay / this.state.station.mRemuneration)} kWh</span>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 border-right">
                                                <div className="description-block">
                                                    <h5 className="description-header">Yesterday</h5>
                                                    <span className="description-text">{this.formatNumber(this.state.money.summaryYesterday)} USD</span>
                                                    <br></br>
                                                    <span className="description">{this.formatNumber(this.state.money.summaryYesterday / this.state.station.mRemuneration)} kWh</span>
                                                </div>
                                            </div>
                                            <div className="col-sm-4">
                                                <div className="description-block">
                                                    <h5 className="description-header">This year</h5>
                                                    <span className="description-text">{this.formatNumberWithInteger(this.state.moneyOfYear.summaryYear)} USD</span>
                                                    <br></br>
                                                    <span className="description">{this.formatNumber(this.state.moneyOfYear.summaryYear / this.state.station.mRemuneration / 1000)} MWh</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="icon">
                                        <i className="ion ion-cash"></i>
                                    </div>
                                </div>
                                {this.getRenderMaps()}
                            </div>
                        </div>

                        <div className="row mt-2 d-flex flex-column">
                            <div className="col-md-12 d-flex">
                                <div className="col-md-12 bg-light pb-0">
                                    <div style={{ padding: ".25rem" }}>
                                        <div className="row d-flex justify-content-between">
                                            {this.getBody(inverters)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}